import { DealData, DealField } from "../../../../Models/ambassador";

export const EMPTY_DEAL: DealData = {
  company_name: "",
  customer_relationship: null,
  company_website: "",
  company_country: "",
  contact_name: "",
  contact_role: "",
  contact_email: "",
  contact_agreed: null,
  title: "",
  opportunity_type: null,
  description: "",
  service_areas: [],
  deal_readiness: null,
  expected_start: "",
  expected_volume: null,
  currency: "EUR",
  contribution: null,
  next_step: "",
  additional_info: "",
  data_protection_confirmed: false,
};

export const DEAL_FIELDS = Object.keys(EMPTY_DEAL) as DealField[];

export const STEP_KEYS = [
  "customer",
  "project",
  "classification",
  "review",
] as const;

/** Required fields per step, as the backend checks them on submission. */
const REQUIRED: DealField[][] = [
  ["company_name", "customer_relationship"],
  ["title", "opportunity_type", "description", "service_areas"],
  [],
  ["data_protection_confirmed"],
];

const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export type DealErrors = Partial<Record<DealField, string>>;

const isEmpty = (value: unknown) =>
  value === null ||
  value === "" ||
  value === false ||
  (Array.isArray(value) && value.length === 0);

/** Error message keys (namespace "ambassador") of one step's fields. */
export const validateStep = (data: DealData, step: number): DealErrors => {
  const errors: DealErrors = {};
  REQUIRED[step]?.forEach((field) => {
    if (isEmpty(data[field])) {
      errors[field] =
        field === "data_protection_confirmed"
          ? "wizard.errors.confirmRequired"
          : "wizard.errors.required";
    }
  });
  if (
    step === 0 &&
    data.contact_email &&
    !EMAIL.test(data.contact_email.trim())
  ) {
    errors.contact_email = "wizard.errors.email";
  }
  return errors;
};

export const validateAll = (
  data: DealData,
): { step: number; errors: DealErrors } | null => {
  for (let step = 0; step < STEP_KEYS.length; step += 1) {
    const errors = validateStep(data, step);
    if (Object.keys(errors).length) return { step, errors };
  }
  return null;
};

/** The form values of a saved deal. */
export const toFormData = (deal: Partial<DealData>): DealData =>
  DEAL_FIELDS.reduce(
    (data, field) =>
      deal[field] === undefined ? data : { ...data, [field]: deal[field] },
    { ...EMPTY_DEAL },
  );
